/**
 * Pre-compiled en messages for SearchInput
 * Generated by @internationalized/string-compiler
 * DO NOT EDIT MANUALLY
 */

export default { clearInput: `Clear search input` };
